/**
 * @generated SignedSource<<f79037fa2bd3bd1501d16e3dcfb838c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoListItemTags_tag$data = ReadonlyArray<{
  readonly color: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "TodoListItemTags_tag";
}>;
export type TodoListItemTags_tag$key = ReadonlyArray<{
  readonly " $data"?: TodoListItemTags_tag$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemTags_tag">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoListItemTags_tag",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "TodoCategoryTag",
  "abstractKey": null
};

(node as any).hash = "939657b0edeffef7da8d1f18b9c13431";

export default node;
